import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Heading from "../components/heading";
import FeatureCard from "../components/faqcards";
import Feature1 from "../assets/features1.png";
import Feature2 from "../assets/features2.png";
import Feature3 from "../assets/features3.png";
import Feature4 from "../assets/features4.png";
import styled from "@emotion/styled";
import Feature5 from "../assets/features5.png";
import { AllImage } from "../styling/style";

const BoxStyle = styled(Box)`
  background: linear-gradient(to top, #fe8d46, #ee5867);
  border-radius: 20px;
  padding: 20px 20px 0px;
  margin: 5px auto 0px;
`;
const GridStyle = styled(Grid)`
  display: flex;
  justify-content: center;
  margin: auto;
  @media (max-width: 900px) {
    margin-bottom: 20px;
  }
`;
const BDiv = styled.div`
  display: flex;
  align-items: center;
  @media (min-width: 700px) and (max-width: 900px) {
    justify-content: center;
  }
`;
const Features = () => {
  return (
    <Container maxWidth="lg" id="features">
      <Grid container>
        <Heading title="Features" />
        <Grid
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            margin: "auto auto 30px",
          }}
        >
          <Typography
            variant="subtitle-1"
            sx={{
              color: "#ffffff",
              textAlign: "center",
              margin: "auto auto 30px",
              maxWidth: "570px",
            }}
          >
            Peachy Trader's feature set simplifies crypto, ensuring users make
            informed decisions with ease.
          </Typography>
        </Grid>
        <Grid xs={12} md={4} order={{ xs: 2, sm: 2, md: 1 }}>
          <FeatureCard
            image={Feature1}
            tag="Real Time Alerts"
            data={[["Receive real-time alerts about tokens exhibiting noteworthy volume surges."]]}
          />
          <div style={{ paddingTop: "30px" }}>
            <FeatureCard
              image={Feature3}
              tag="Insightful Data"
              data={[
                [
                  "Access a condensed yet comprehensive data digest for each highlighted token.",
                ],
              ]}
            />
          </div>
        </Grid>
        <GridStyle
          xs={12}
          sm={6}
          md={4}
          order={{ xs: 1, sm: 1, md: 2 }}
          data-aos="zoom-in"
          data-aos-duration="1500"
        >
          <BoxStyle>
            <Typography color="white" fontFamily="poppins-semibold">
              TELEGRAM BOT
            </Typography>
            <Typography
              sx={{
                color: "white",
                fontFamily: "poppins-regular",
                fontSize: "14px",
              }}
            >
              An easy to use tool that provides updates about hyped up tokens in an accessible manner.
            </Typography>
            <BDiv>
              <AllImage maxw="335px" src={Feature5} />
            </BDiv>
          </BoxStyle>
        </GridStyle>
        <Grid xs={12} md={4} order={{ xs: 3, sm: 3, md: 3 }}>
          <FeatureCard
            image={Feature2}
            tag="Lower Downtime"
            data={[
              [
                "Quickly assess tokens for potential sustained growth or sudden shifts in sentiment. Adapt your strategy to dynamic market conditions.",
              ],
            ]}
          />
          <div style={{ paddingTop: "30px" }}>
            <FeatureCard
              image={Feature4}
              tag="Smart Analysis"
              data={[
                [
                  "The Peachy Signals Bot distinguishes between regular fluctuations and noteworthy volume changes, ensuring the information you receive is relevant and actionable.",
                ],
              ]}
            />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};
export default Features;
